import { loaderAction, setExtendSubscriptionFormAction } from "../rootReducer";
import growl from "../../lib/growl/growl";
import { setLocalStorage } from "../../helpers/LocalStorage";
import { api } from "../../helpers/api";
import { getSubscriptionsSagaAction, getUserInfoSagaAction } from "../sagaActions";
import { EXTEND_SUBSCRIPTION_FORM_INITIAL } from "../initialStateConstant";

export const ExtendSubscriptionThunk = (args) => async (dispatch, getState) => {
    const { user, currentUser } = getState();

    dispatch(loaderAction(true));

    try {
        let formData = new FormData();
        formData.append('user_id', user.id);
        formData.append('hash', user.hash);

        formData.append('subscription_id', args.subscription_id);
        formData.append('expire_date', args.expire_date);

        const response = await api({ data: formData, link: 'extend_subscription' });

        // Если не прошли проверку хеша разлогиниваемся
        if (response.void) {
            setLocalStorage('afp_fitness', '').then(() => window.location.reload());
        }

        if (response.success) {
            // Сбрасываем форму продления срока действия абонемента
            dispatch(setExtendSubscriptionFormAction(EXTEND_SUBSCRIPTION_FORM_INITIAL));

            // Если продлевали абонемент на странице пользователя
            if (currentUser.id) {
                // Обновляем данные пользователя (с абонементами)
                dispatch(getUserInfoSagaAction({ id: currentUser.id }));
            }
            // Если продлевали абонемент на странице с абонементами
            else {
                // Обновляем список с абонементами
                dispatch(getSubscriptionsSagaAction());
            }
            growl({ type: 'success', message: response.message });
        }
        else if (response.error) {
            growl({ type: 'error', message: response.message });
        }
    }
    catch(error) {
        console.log(error);
    }
    finally {
        dispatch(loaderAction(false));
    }
};